"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Downloads = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _icons = require("@material-ui/icons");

var _Hocs = require("../../Hocs");

var _useStyles2 = _interopRequireDefault(require("./useStyles"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var Downloads = function Downloads(_ref) {
  var lists = _ref.lists,
      gridItem = _ref.gridItem;

  var _useStyles = (0, _useStyles2["default"])(),
      wrapper = _useStyles.wrapper,
      title = _useStyles.title,
      size = _useStyles.size,
      icon = _useStyles.icon;

  return /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    container: true,
    component: "ul",
    spacing: 4,
    style: {
      padding: 0
    }
  }, lists.filter(function (item) {
    return item.path && item.contentType;
  }).map(function (list, i) {
    return /*#__PURE__*/_react["default"].createElement(_core.Grid, _extends({
      key: list.path.concat(i),
      container: true,
      item: true,
      component: "li",
      justify: "center"
    }, gridItem), /*#__PURE__*/_react["default"].createElement(_core.Grid, {
      container: true,
      item: true,
      key: list.title,
      justify: "space-between",
      alignItems: "center",
      spacing: 2,
      className: wrapper
    }, /*#__PURE__*/_react["default"].createElement(_core.Grid, {
      item: true
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: title
    }, list.title), /*#__PURE__*/_react["default"].createElement("span", {
      className: size
    }, list.size ? list.contentType.concat(' ', list.size) : list.contentType)), /*#__PURE__*/_react["default"].createElement(_core.Grid, {
      item: true
    }, /*#__PURE__*/_react["default"].createElement(_core.IconButton, {
      "aria-label": "Download file",
      component: "a",
      download: true,
      href: list.path
    }, /*#__PURE__*/_react["default"].createElement(_icons.GetApp, {
      className: icon
    })))));
  }));
};

exports.Downloads = Downloads;
Downloads.defaultProps = {
  gridItem: {}
};
Downloads.propTypes = {
  /**
   * The list attribute is type-checked via `renderListSafely` HOC.
   */
  lists: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    title: _propTypes["default"].string.isRequired,
    size: _propTypes["default"].number,
    contentType: _propTypes["default"].string.isRequired,
    path: _propTypes["default"].string.isRequired
  }).isRequired).isRequired,

  /**
   * Used to customize the width of each download. This matches MUI's underlying grid item props.
   */
  gridItem: _propTypes["default"].shape({
    xs: _propTypes["default"].number,
    sm: _propTypes["default"].number,
    md: _propTypes["default"].number,
    lg: _propTypes["default"].number
  })
};

var _default = (0, _Hocs.renderListSafely)(Downloads);

exports["default"] = _default;